import { authenticatedFetch } from '../../../auth/auth';
const base = (import.meta.env.VITE_API_BASE_URL || import.meta.env.VITE_API_URL || '').replace(/\/$/, '');
export async function requestOrderMessage(path, body, method = 'POST', signal) {
  const response = await authenticatedFetch(`${base}/api/order-messages${path}`, { method: body === undefined ? 'GET' : method, cache: 'no-store', signal, ...(body === undefined ? {} : { headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }) });
  const result = await response.json().catch(() => ({}));
  if (response.status === 404 && ['/status', '/templates', '/previews', '/send', '/runs'].includes(path)) throw new Error('Esta função ainda não está disponível no backend em execução. Atualize e recrie o container da API com os arquivos do pacote.');
  if (!response.ok || result.ok === false) throw new Error(result.message || `Não foi possível concluir a solicitação (HTTP ${response.status}).`);
  return result;
}
export async function waitForOrderMessageJob(endpoint, input) {
  let { job } = await requestOrderMessage(endpoint, input);
  const deadline = Date.now() + 12 * 60000;
  while (job.status === 'running') {
    if (Date.now() > deadline) throw new Error('A consulta ainda está em andamento. Aguarde e tente novamente.');
    await new Promise(resolve => setTimeout(resolve, 1500));
    ({ job } = await requestOrderMessage(`${endpoint}/${job.id}`));
  }
  if (job.status !== 'completed') throw new Error(job.error || 'Não foi possível gerar a prévia.');
  return job.result;
}

export const prepareOrderMessage = input => waitForOrderMessageJob("/previews", input);
